
import { Button, Dialog } from "@mui/material";
import { useEffect, useState } from "react";
import useAuth from "../hooks/useAuth";
import { useTheme } from "../hooks/useTheme";
import colorConfigs from "../../configs/colorConfigs";
import { freeVehicleChange } from "../../services/rental";
import Cookies from "js-cookie";
import useTenant from "../hooks/useTenant";

type FreeVehicleClassChangeProps = {
    freeVehicleClassChangeOpen: boolean;
    setFreeVehicleClassChangeOpen: (value: boolean) => void;
    vehicleClassId: number;
    setVehicleClassId: (value: number) => void;
    setSelectedVehiclesClass: (value: any) => void;
    reservationId: number;
    refreshTheSummary: () => void;
    availableVehicle: any[];
    setPleaseWaitPopup: (value: boolean) => void;
}

const FreeVehicleClassChange = ({
    freeVehicleClassChangeOpen,
    setFreeVehicleClassChangeOpen,
    vehicleClassId,
    setVehicleClassId,
    setSelectedVehiclesClass,
    reservationId,
    refreshTheSummary,
    availableVehicle,
    setPleaseWaitPopup

}: FreeVehicleClassChangeProps) => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { theme, themeStyles } = useTheme();
    const { auth }: any = useAuth();
    const { handleTenantError }: any = useTenant();
    const [availableVehicleClass, setAvailableVehicleClass] = useState<any[]>([]);
    const [selectedNewVehicleClass, setSelectNewVehicleClass] = useState<number>(0);
    const [vehicleClassAlert, setVehicleClassAlert] = useState<string>("");
    const closeIconFill = theme === "dark" ? "fill-[#E4E7EC]" : "fill-[#1D2939]";

    useEffect(() => {
        if (availableVehicle?.length > 0) {
            setAvailableVehicleClass(() =>
                availableVehicle
                    ?.filter((item: any) => item?.vehicleClassId !== vehicleClassId)
                    ?.map((item: any) => {
                        return {
                            value: item.vehicleClassId,
                            label: item.vehicleLabel,
                            availableVehicles: item.availableVehicles
                        }
                    }));
        } else {
            setAvailableVehicleClass([]);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps    
    }, [availableVehicle, vehicleClassId]);

    useEffect(() => {
        if (selectedNewVehicleClass > 0) {
            if (availableVehicleClass?.find((vehcileClass: any) => vehcileClass?.value === selectedNewVehicleClass)?.availableVehicles > 0) {
                setVehicleClassAlert("");
            } else {
                setVehicleClassAlert("*This vehicle class is not available!");
            }
        } else {
            setVehicleClassAlert("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps    
    }, [selectedNewVehicleClass])

    const handleSubmit = async () => {
        if (selectedNewVehicleClass > 0) {
            if (availableVehicleClass?.find((vehcileClass: any) => vehcileClass?.value === selectedNewVehicleClass)?.availableVehicles > 0) {
                setVehicleClassAlert("");

                freeVehicleChange(
                    reservationId,
                    selectedNewVehicleClass,
                    auth?.id,
                    tenantId
                )
                    .then(() => {
                        const selectedFreeVehicleClass = availableVehicle?.find((item: any) => item?.vehicleClassId === selectedNewVehicleClass);

                        setVehicleClassId(selectedFreeVehicleClass?.vehicleClassId);
                        setSelectedVehiclesClass(selectedFreeVehicleClass);
                        refreshTheSummary();
                        setFreeVehicleClassChangeOpen(false);
                        handleTenantError(null);
                    })
                    .catch(error => {
                        setPleaseWaitPopup(false);
                       handleTenantError(error);
                    });
            } else {
                setVehicleClassAlert("*This vehicle class is not available!");
            }
        } else {
            setVehicleClassAlert("*Please select a vehicle class!");
        }
    }


    return (
        <>
            <Dialog
                open={freeVehicleClassChangeOpen}
                maxWidth="md"
                fullScreen={false}
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '400px',
                        width: '100%',
                        borderRadius: '16px',
                    },
                }}
            >
                <div className={`px-[15px] py-[15px] h-full ${themeStyles.main.tailwindSectionBg}`}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320.591 320.591"
                        className={`w-3 cursor-pointer float-right ${closeIconFill}`}
                        onClick={() => setFreeVehicleClassChangeOpen(false)}
                    >
                        <path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" />
                        <path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" />
                    </svg>
                    <div className={`w-full bg-transparent rounded-lg p-[10px] flex flex-col gap-2.51`}>
                        <div className="w-full mt-2">
                            <div className={`w-full`}>
                                <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                                    <div className="flex items-center gap-1.5">
                                        <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Free Vehicle Class Change</h2>
                                    </div>
                                </div>

                                <div className="mt-2 p-2">
                                    <div className="w-full">
                                        <div>
                                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>New Vehicle Class</label>
                                            <select
                                                className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                value={selectedNewVehicleClass}
                                                onChange={(e) =>
                                                    setSelectNewVehicleClass(parseInt(e.target.value))
                                                }
                                                required
                                            >
                                                <option className={`${themeStyles.main.tailwindSectionBg}`} value="0">{" "}</option>

                                                {availableVehicleClass?.map((item: any, index: number) => {
                                                    return <option className={`${themeStyles.main.tailwindSectionBg}`} key={index} value={item.value}>{item.label}</option>;
                                                })}
                                            </select>
                                            <br />
                                            {vehicleClassAlert && <span className="text-sm text-red-500">{vehicleClassAlert}</span>}
                                        </div>
                                    </div>

                                    <div className="mt-4 w-full flex gap-4">
                                        <Button variant="contained"
                                            sx={{
                                                backgroundColor: colorConfigs.btn.main.bg
                                            }}
                                            onClick={handleSubmit}
                                        >
                                            Save
                                        </Button>

                                        <Button variant="contained"
                                            sx={{
                                                backgroundColor: colorConfigs.btn.cancel.bg,
                                                border: colorConfigs.btn.cancel.border,
                                                color: colorConfigs.btn.cancel.color
                                            }}
                                            onClick={() => setFreeVehicleClassChangeOpen(false)}>
                                            Cancel
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    )
}

export default FreeVehicleClassChange;